export function flattenImages(arr) {
    return arr.reduce((acc, item) => {
        if (!item) return acc;  // skip undefined/null
        return acc.concat(Array.isArray(item) ? flattenImages(item) : [item]);
    }, []);
}

export function preloadImages(srcs) {
    return Promise.all(srcs.map(src => new Promise((resolve) => {
        const img = new Image();
        img.src = src;
        img.onload = resolve;
        img.onerror = resolve;
    })));
}

export const PASCImage = `/assets/graphic-work/school-projects/PASCPoster.png`;
export const DuckImage = `/assets/graphic-work/school-projects/DigitalDuckPoster.png`;
export const Headshot = `/assets/headshot.png`;

export const Fliers = [
    `/assets/graphic-work/uc-merced-work/fliers/fafsa.png`,
    `/assets/graphic-work/uc-merced-work/fliers/what-to-bring.png`,
    `/assets/graphic-work/uc-merced-work/fliers/music-as-science.png`,
    `/assets/graphic-work/uc-merced-work/fliers/smart-start.png`,
    `/assets/graphic-work/uc-merced-work/fliers/downtown.png`,
    `/assets/graphic-work/uc-merced-work/fliers/business.png`,
    `/assets/graphic-work/uc-merced-work/fliers/piqs.png`,
    `/assets/graphic-work/uc-merced-work/fliers/esports.png`,
    `/assets/graphic-work/uc-merced-work/fliers/inside-hosts.png`,
    `/assets/graphic-work/uc-merced-work/fliers/inside-participants.png`,
    `/assets/graphic-work/uc-merced-work/fliers/extension.png`,
    // DEGREE COMPLETION
    [
        `/assets/graphic-work/uc-merced-work/fliers/degree-completion/degree-completion-1.png`,
        // `/assets/graphic-work/uc-merced-work/fliers/degree-completion/degree-completion-2.png`,
    ],
    // PIQS TRANSFER
    [
        `/assets/graphic-work/uc-merced-work/fliers/piqs-transfer/piqs-transfer-1.png`,
        `/assets/graphic-work/uc-merced-work/fliers/piqs-transfer/piqs-transfer-2.png`,
    ],
    // TPP SUMMER
    [
        `/assets/graphic-work/uc-merced-work/fliers/tpp-summer/tpp-summer-1.png`,
        `/assets/graphic-work/uc-merced-work/fliers/tpp-summer/tpp-summer-2.png`,
    ],
    // SELECT A UNI
    [
        `/assets/graphic-work/uc-merced-work/fliers/select-a-uni/select-a-uni-1.png`,
        `/assets/graphic-work/uc-merced-work/fliers/select-a-uni/select-a-uni-2.png`,
        `/assets/graphic-work/uc-merced-work/fliers/select-a-uni/select-a-uni-3.png`,
        `/assets/graphic-work/uc-merced-work/fliers/select-a-uni/select-a-uni-4.png`,
        `/assets/graphic-work/uc-merced-work/fliers/select-a-uni/select-a-uni-5.png`,
        `/assets/graphic-work/uc-merced-work/fliers/select-a-uni/select-a-uni-6.png`,
    ],

];

export const Thumbnails = [
    `/assets/graphic-work/uc-merced-work/thumbnails/1-bcl-polisci.jpg`,
    `/assets/graphic-work/uc-merced-work/thumbnails/2-electrical.jpg`,
    `/assets/graphic-work/uc-merced-work/thumbnails/3-admitted.jpg`,
    `/assets/graphic-work/uc-merced-work/thumbnails/4-bcl-paleo.jpg`,
    `/assets/graphic-work/uc-merced-work/thumbnails/5-engineering.jpg`,
    `/assets/graphic-work/uc-merced-work/thumbnails/6-prehealth.jpg`,
    `/assets/graphic-work/uc-merced-work/thumbnails/7-bcl-receptions.jpg`,
    `/assets/graphic-work/uc-merced-work/thumbnails/8-undeclared.jpg`,
    `/assets/graphic-work/uc-merced-work/thumbnails/9-newmajors.jpg`,
    `/assets/graphic-work/uc-merced-work/thumbnails/10-cookingdemo.png`,
    `/assets/graphic-work/uc-merced-work/thumbnails/11-aerospace.jpg`,
    `/assets/graphic-work/uc-merced-work/thumbnails/12-international.jpg`,
];

export const ThumbnailShowcase = [
    // BOBCAT LIFE
    [
        `/assets/graphic-work/uc-merced-work/thumbnails/bobcat-life/bl-1.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/bobcat-life/bl-2.png`,
        `/assets/graphic-work/uc-merced-work/thumbnails/bobcat-life/bl-3.png`,
        `/assets/graphic-work/uc-merced-work/thumbnails/bobcat-life/bl-4.png`,
        `/assets/graphic-work/uc-merced-work/thumbnails/bobcat-life/bl-5.png`,
        `/assets/graphic-work/uc-merced-work/thumbnails/bobcat-life/bl-6.jpg`
    ],
    // OTHERS
    [
        `/assets/graphic-work/uc-merced-work/thumbnails/other/admit.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/other/cooking.jpg`
    ],
    // 2024 WEBINARS
    [
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-blue/d-1.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-blue/d-2.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-blue/d-3.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-blue/d-4.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-blue/d-5.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-blue/d-6.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-blue/d-7.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-blue/d-8.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-blue/d-9.jpg`
    ],
    // 2025 WEBINARS
    [
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-1.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-2.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-3.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-4.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-5.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-6.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-7.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-8.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-9.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-10.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-11.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-12.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-13.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-14.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-15.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-16.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-17.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-18.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-19.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-20.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-21.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-22.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-23.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-24.jpg`,
        `/assets/graphic-work/uc-merced-work/thumbnails/webinar-2025/bab-25.jpg`
    ]
];

export const Logos = [
    `/assets/graphic-work/uc-merced-work/logos/bobcatlife.png`,
    `/assets/graphic-work/uc-merced-work/logos/summeratucm.png`,
    `/assets/graphic-work/uc-merced-work/logos/moc-circle.png`,
    `/assets/graphic-work/uc-merced-work/logos/moc-text.png`,
    //MEDIA CATS
    [
        `/assets/graphic-work/uc-merced-work/logos/mc/mc-1.png`,
        `/assets/graphic-work/uc-merced-work/logos/mc/mc-2.png`,
        `/assets/graphic-work/uc-merced-work/logos/mc/mc-3.png`,
        `/assets/graphic-work/uc-merced-work/logos/mc/mc-4.png`
    ],
    // UCRC LOGO
    [
        `/assets/graphic-work/uc-merced-work/logos/ucrc-logo/ucrc-logo-1.png`,
        `/assets/graphic-work/uc-merced-work/logos/ucrc-logo/ucrc-logo-2.png`,
        `/assets/graphic-work/uc-merced-work/logos/ucrc-logo/ucrc-logo-3.png`,
        `/assets/graphic-work/uc-merced-work/logos/ucrc-logo/ucrc-logo-4.png`,
        `/assets/graphic-work/uc-merced-work/logos/ucrc-logo/ucrc-logo-5.png`,
        `/assets/graphic-work/uc-merced-work/logos/ucrc-logo/ucrc-logo-6.png`
    ],
    // MC PRODUCTIONS
    [
        `/assets/graphic-work/uc-merced-work/logos/mc-prod/prod-1.png`,
        `/assets/graphic-work/uc-merced-work/logos/mc-prod/prod-2.png`,
        `/assets/graphic-work/uc-merced-work/logos/mc-prod/prod-3.png`,
        `/assets/graphic-work/uc-merced-work/logos/mc-prod/prod-4.png`
    ],
    // UCRC TEXT
    [
        `/assets/graphic-work/uc-merced-work/logos/ucrc-text/ucrc-text-1.png`,
        `/assets/graphic-work/uc-merced-work/logos/ucrc-text/ucrc-text-2.png`,
        `/assets/graphic-work/uc-merced-work/logos/ucrc-text/ucrc-text-3.png`,
        `/assets/graphic-work/uc-merced-work/logos/ucrc-text/ucrc-text-4.png`,
        `/assets/graphic-work/uc-merced-work/logos/ucrc-text/ucrc-text-5.png`,
        `/assets/graphic-work/uc-merced-work/logos/ucrc-text/ucrc-text-6.png`
    ],
    `/assets/graphic-work/uc-merced-work/logos/askamediacat.png`,
    `/assets/graphic-work/uc-merced-work/logos/askamediacat-summer.png`,
    `/assets/graphic-work/uc-merced-work/logos/ee.png`,
    `/assets/graphic-work/uc-merced-work/logos/sticker.png`
]

export const SocialMedia = [
    `/assets/graphic-work/uc-merced-work/social-media/movein.jpg`,
    // Welcome To UC Merced
    [
        `/assets/graphic-work/uc-merced-work/social-media/welcome/welcome-1.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/welcome/welcome-2.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/welcome/welcome-3.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/welcome/welcome-4.jpg`,
    ],
    `/assets/graphic-work/uc-merced-work/social-media/yosemite.jpg`,
    // Bobcat Day
    [
        `/assets/graphic-work/uc-merced-work/social-media/bd/bd-1.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/bd/bd-2.jpg`
    ],
    `/assets/graphic-work/uc-merced-work/social-media/awards.jpg`,
    `/assets/graphic-work/uc-merced-work/social-media/water-polo.jpg`,
    `/assets/graphic-work/uc-merced-work/social-media/job-post.jpg`,
    `/assets/graphic-work/uc-merced-work/social-media/experience/bobcatday.jpg`,
    // Experience UC Merced
    [
        `/assets/graphic-work/uc-merced-work/social-media/experience/experience-1.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/experience/experience-2.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/experience/experience-3.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/experience/journey.jpg`
    ],
    // Living Tips
    [
        `/assets/graphic-work/uc-merced-work/social-media/living-tips/livingtips-1.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/living-tips/livingtips-2.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/living-tips/livingtips-3.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/living-tips/livingtips-4.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/living-tips/livingtips-5.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/living-tips/livingtips-6.jpg`
    ],
    // Summer At UC Merced
    [
        `/assets/graphic-work/uc-merced-work/social-media/summer/summer-1.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/summer/summer-2.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/summer/summer-3.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/summer/summer-4.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/summer/summer-5.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/summer/summer-6.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/summer/summer-7.jpg`
    ],
    `/assets/graphic-work/uc-merced-work/social-media/fresno.jpg`,
        // Pass The paw
    [
        `/assets/graphic-work/uc-merced-work/social-media/ptp/ptp-1.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/ptp/ptp-2.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/ptp/ptp-3.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/ptp/ptp-4.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/ptp/ptp-5.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/ptp/ptp-6.jpg`
    ],
    // Valentines
    [
        `/assets/graphic-work/uc-merced-work/social-media/valentines/valentines-1.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/valentines/valentines-2.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/valentines/valentines-3.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/valentines/valentines-4.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/valentines/valentines-5.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/valentines/valentines-6.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/valentines/valentines-7.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/valentines/valentines-8.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/valentines/valentines-9.jpg`
    ],
        // Thanksgiving
    [
        `/assets/graphic-work/uc-merced-work/social-media/thanksgiving/thanksgiving-1.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/thanksgiving/thanksgiving-2.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/thanksgiving/thanksgiving-3.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/thanksgiving/thanksgiving-4.jpg`,
        `/assets/graphic-work/uc-merced-work/social-media/thanksgiving/thanksgiving-5.jpg`
    ]
];

// FREELANCE

export const SunsetMediaWave = [
    `/assets/graphic-work/freelance-design/smw/smw-11.png`,
    `/assets/graphic-work/freelance-design/smw/smw-1.png`,
    `/assets/graphic-work/freelance-design/smw/smw-2.png`,
    `/assets/graphic-work/freelance-design/smw/smw-3.png`,
    `/assets/graphic-work/freelance-design/smw/smw-4.png`,
    `/assets/graphic-work/freelance-design/smw/smw-7.png`,
    `/assets/graphic-work/freelance-design/smw/smw-8.png`,
    `/assets/graphic-work/freelance-design/smw/smw-5.png`,
    `/assets/graphic-work/freelance-design/smw/smw-6.png`,
    `/assets/graphic-work/freelance-design/smw/smw-9.png`,
    `/assets/graphic-work/freelance-design/smw/smw-10.png`
];

export const StoryWorks = [
    `/assets/graphic-work/freelance-design/storyworks/storyworks-1.jpg`,
    `/assets/graphic-work/freelance-design/storyworks/storyworks-2.jpg`,
    `/assets/graphic-work/freelance-design/storyworks/storyworks-3.jpg`,
    `/assets/graphic-work/freelance-design/storyworks/storyworks-4.jpg`,
    `/assets/graphic-work/freelance-design/storyworks/storyworks-5.jpg`,
    `/assets/graphic-work/freelance-design/storyworks/storyworks-6.jpg`,
    `/assets/graphic-work/freelance-design/storyworks/storyworks-7.jpg`,
    `/assets/graphic-work/freelance-design/storyworks/storyworks-8.jpg`,
    `/assets/graphic-work/freelance-design/storyworks/storyworks-9.jpg`,
    `/assets/graphic-work/freelance-design/storyworks/storyworks-10.jpg`,
    `/assets/graphic-work/freelance-design/storyworks/storyworks-11.jpg`,
    `/assets/graphic-work/freelance-design/storyworks/storyworks-12.jpg`,
    `/assets/graphic-work/freelance-design/storyworks/storyworks-13.jpg`,
    `/assets/graphic-work/freelance-design/storyworks/storyworks-14.jpg`,
    `/assets/graphic-work/freelance-design/storyworks/storyworks-15.jpg`,
    `/assets/graphic-work/freelance-design/storyworks/storyworks-16.jpg`,
    `/assets/graphic-work/freelance-design/storyworks/storyworks-17.jpg`,
    `/assets/graphic-work/freelance-design/storyworks/storyworks-18.jpg`,
    `/assets/graphic-work/freelance-design/storyworks/storyworks-19.jpg`,
    `/assets/graphic-work/freelance-design/storyworks/storyworks-20.jpg`,
    `/assets/graphic-work/freelance-design/storyworks/storyworks-21.jpg`,
    `/assets/graphic-work/freelance-design/storyworks/storyworks-22.jpg`
];

export const EllisTom = [
    `/assets/graphic-work/freelance-design/ellis-tom/unplanned-films.png`,
    `/assets/graphic-work/freelance-design/ellis-tom/mindsets-1.png`,
    `/assets/graphic-work/freelance-design/ellis-tom/mindsets-2.png`,
    `/assets/graphic-work/freelance-design/ellis-tom/stress-1.png`,
    `/assets/graphic-work/freelance-design/ellis-tom/stress-2.png`,
    `/assets/graphic-work/freelance-design/ellis-tom/tbhitcv.png`,
    `/assets/graphic-work/freelance-design/ellis-tom/wells-of-hope.png`,
    `/assets/graphic-work/freelance-design/ellis-tom/ucsd-1.png`,
    `/assets/graphic-work/freelance-design/ellis-tom/ucsd-2.png`,
    `/assets/graphic-work/freelance-design/ellis-tom/ucsd-3.png`,
    `/assets/graphic-work/freelance-design/ellis-tom/ucsd-4.png`,
];

export const MoreClients = [
    //UNCIVILIZED
    `/assets/graphic-work/freelance-design/uncivilized/uncivilized.png`,

    //SWELL FOOP
    `/assets/graphic-work/freelance-design/swell-foop/swell-foop-1.png`,
    `/assets/graphic-work/freelance-design/swell-foop/swell-foop-2.png`,
    `/assets/graphic-work/freelance-design/swell-foop/swell-foop-3.png`,
    `/assets/graphic-work/freelance-design/swell-foop/swell-foop-4.png`,

    //ASUCM
    `/assets/graphic-work/freelance-design/asucm/ammar.png`,
    `/assets/graphic-work/freelance-design/asucm/yasmin.png`,

    `/assets/graphic-work/freelance-design/more-clients/hard-drive-poster.png`,
];